export default "__VITE_ASSET__sIE0p57j__"